<template>
  <p v-html="content"></p>
  <p style="color: red;">【蓝色为标记词，对方已收到】</p>
</template>

<script>
export default {
  name: "FixMsg",
  props: {
    msg: {
      type: String,
      default: ''
    },
    mark: {
      type: String,
      default: ''
    }
  },
  computed: {
    content() {
      let msg = this.msg;
      let mark = this.mark;
      let s = msg.indexOf(mark);
      let l = mark.length;
      let allStr = '';
      for (let i=0; i<msg.length; i++) {
        if( i >= s && i < (s+l)) {
          allStr += "<font style='color: blue;'>" + msg[i] + "</font>";
        }else {
          allStr += msg[i]
        }
      }
      return allStr
    }
  }
}
</script>

<style scoped>

</style>
